import { render, staticRenderFns } from "./ModalPapeis.vue?vue&type=template&id=52597d47&scoped=true"
import script from "./ModalPapeis.vue?vue&type=script&lang=js"
export * from "./ModalPapeis.vue?vue&type=script&lang=js"
import style0 from "./ModalPapeis.vue?vue&type=style&index=0&id=52597d47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52597d47",
  null
  
)

export default component.exports